<template>
  <div>
    <svg :viewBox="viewBox"
         :width="width"
         :height="height"
         :class="'icon' + ' ' + cssClass">
      <use v-bind="{'xlink:href' : svgIcons + '#' + name}" ></use>
    </svg>
  </div>
</template>


<script>
  import svgIcons from '../assets/images/icons.svg'

  export default {
    data() {
      return {
        svgIcons
      }
    },
    props: {
      name: String,
      viewBox: {
        type: String,
        default: '0 0 24 24'
      },
      width: {
        type: [Number, String],
        default: 24
      },
      height: {
        type: [Number, String],
        default: 24
      },
      cssClass: {
        type: String
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  }
</script>

<style scoped>
  div {
    display: inline-block;
  }
</style>

